import React, { useState } from 'react';
import imagesData from '../data/images';
import './Gallery.css';

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <div>
      <h2>Galeria</h2>
      <div className="gallery-container">
        {imagesData.map((img) => (
          <div 
            className="gallery-item" 
            key={img.id}
            onClick={() => setSelectedImage(img)}
          >
            <img src={img.src} alt={img.title} />
            <div className="gallery-caption">{img.title}</div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div 
          className="overlay" 
          onClick={() => setSelectedImage(null)}
        >
          <div className="image-container">
            <img 
              src={selectedImage.src} 
              alt={selectedImage.title}
              className="enlarged-image"
            />
            <div className="image-title">{selectedImage.description}</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;